import React, { useMemo } from 'react';
import styled from 'styled-components';

interface ClipTextProps {
  text: string;
  maxLength: number;
  isTextClip?: boolean;
}

const ClipText: React.FC<ClipTextProps> = ({ text, maxLength, isTextClip = true }) => {
  const textToDisplay = useMemo(() => {
    if (text.length > maxLength && isTextClip) {
      return text.slice(0, maxLength - 1) + '...';
    }
    return text;
  }, [text, maxLength, isTextClip]);
  return <DisplayText>{textToDisplay.replace(/\s+/g, ' ').trim()}</DisplayText>;
};

const DisplayText = styled.span`
  whitespace: 'nowrap';
`;

export default ClipText;
